var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", [
    _c("caption", [_vm._v("Carrier Information")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("tbody", [
      _c("tr", [
        _c("td", [_vm._v(_vm._s(_vm.carrierName))]),
        _vm._v(" "),
        _c("td", [
          _vm.trackingPage
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.trackingPage.replace(
                      "{connote}",
                      _vm.consignmentNote
                    ),
                    target: "_blank",
                  },
                },
                [_vm._v("Tracking Link")]
              )
            : _c("span", [_vm._v("N/A")]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Additional Scanning Information")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }